import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './formula2b.css'

const Formula2b = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <div className={`formula2b-container10 ${props.rootClassName} `}>
      {isVisible === false && (
        <div className="formula2b-container11">
          <div className="formula2b-thq-formula-elm1">
            <div className="formula2b-thq-container-elm1">
              <span className="formula_blue">{props.text1}</span>
              <div className="formula2b-container12">
                <span className="formula_text">{props.text12}</span>
                <span className="formula_paragraph">{props.text13}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt13}
              src={props.imageSrc11}
              className="formula_arrow"
            />
            <div className="formula2b-thq-container-elm2">
              <span className="formula_blue">{props.text2}</span>
              <div className="formula2b-container13">
                <span className="formula_text">{props.text14}</span>
                <span className="formula_paragraph">{props.text15}</span>
              </div>
              <p
                onTouchEnd={() => setIsVisible(false)}
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                onTouchStart={() => setIsVisible(true)}
                className="formula_button formula2b-thq-caption-elm1"
              >
                {props.caption22}
              </p>
            </div>
            <img
              alt={props.imageAlt21}
              src={props.imageSrc22}
              className="formula_arrow"
            />
            <div className="formula2b-container14">
              <span className="formula_blue">{props.text3}</span>
              <div className="formula2b-container15">
                <span className="formula_text">{props.text16}</span>
                <span className="formula_paragraph">{props.text17}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt3}
              src={props.imageSrc2}
              className="formula_x"
            />
            <div className="formula2b-container16">
              <span className="formula_blue">{props.text4}</span>
              <div className="formula2b-container17">
                <span className="formula_text">{props.text18}</span>
                <span className="formula_paragraph">{props.text19}</span>
              </div>
              <span className="formula2b-text22 paragraph">{props.text5}</span>
            </div>
            <img
              alt={props.imageAlt12}
              src={props.imageSrc12}
              className="formula_arrow"
            />
            <div className="formula2b-container18">
              <span className="formula2b-text23 formula_blue">
                <span>that&apos;s more than </span>
                <span>€100M</span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </span>
              <div className="formula2b-container19">
                <span className="formula_text">{props.text20}</span>
                <span className="formula_paragraph">{props.text21}</span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === true && (
        <div className="formula2b-thq-container-elm3">
          <div className="formula2b-thq-formula-elm2">
            <div className="formula2b-thq-container-elm4">
              <span className="formula_blue">{props.text110}</span>
              <div className="formula2b-container20">
                <span className="formula_text">{props.text121}</span>
                <span className="formula_paragraph">{props.text131}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt111}
              src={props.imageSrc111}
              className="formula_arrow"
            />
            <div className="formula2b-thq-container-elm5">
              <span className="formula2b-text32 formula_blue">
                {props.text210}
              </span>
              <div className="formula2b-container21">
                <span className="formula_text">{props.text141}</span>
                <span className="formula_paragraph">{props.text151}</span>
              </div>
              <p
                onTouchEnd={() => setIsVisible(false)}
                onMouseLeave={() => setIsVisible(false)}
                onTouchStart={() => setIsVisible(false)}
                className="formula2b-thq-caption-elm2 formula_button"
              >
                {props.caption211}
              </p>
            </div>
            <img
              alt={props.imageAlt211}
              src={props.imageSrc211}
              className="formula_arrow"
            />
            <div className="formula2b-container22">
              <span className="formula2b-text35 formula_blue">
                {props.text31}
              </span>
              <div className="formula2b-container23">
                <span className="formula_text">{props.text161}</span>
                <span className="formula_paragraph">{props.text171}</span>
              </div>
            </div>
            <img
              alt={props.imageAlt81}
              src={props.imageSrc81}
              className="formula_x"
            />
            <div className="formula2b-container24">
              <span className="formula2b-text38 formula_blue">
                {props.text41}
              </span>
              <div className="formula2b-container25">
                <span className="formula_text">{props.text181}</span>
                <span className="formula_paragraph">{props.text191}</span>
              </div>
              <span className="formula2b-text41 paragraph">{props.text51}</span>
            </div>
            <img
              alt={props.imageAlt112}
              src={props.imageSrc112}
              className="formula_arrow"
            />
            <div className="formula2b-container26">
              <span className="formula2b-text42 formula_blue">
                that&apos;s more than €10M
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <div className="formula2b-container27">
                <span className="formula_text">{props.text201}</span>
                <span className="formula_paragraph">{props.text211}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

Formula2b.defaultProps = {
  imageAlt211: 'image',
  imageSrc111: '/formula/arrow_black.svg',
  text31: "we've brought 20K tourists",
  caption22: "I don't agree",
  text51: 'according to the Ministry of Economy, Entrepreneurship and Tourism',
  text3: "we've brought 200K tourists",
  text4: 'multiplied by €550 per tourist',
  imageSrc22: '/formula/arrow_black.svg',
  text18: 'average tourist spend',
  text16: "that's 5%",
  imageAlt81: 'image',
  text2: '1 in 10,000 viewers has visited Romania',
  imageSrc112: '/formula/arrow_black.svg',
  text121: 'since 2019',
  imageSrc81: '/formula/x_black.svg',
  text201: 'to the economy',
  text41: 'multiplied by €550 per tourist',
  text210: '1 in 100,000 viewers has visited Romania',
  imageSrc2: '/formula/x_black.svg',
  caption211: 'How about now?',
  text151: 'text here',
  rootClassName: '',
  text17: 'of total international tourists in Romania in the last 4 years',
  text14: 'text here',
  text19: 'according to the Ministry of Economy, Entrepreneurship and Tourism',
  imageAlt12: 'image',
  imageAlt3: 'image',
  imageSrc11: '/formula/arrow_black.svg',
  text191: 'according to the Ministry of Economy, Entrepreneurship and Tourism',
  text21: 'outside money brought and spent in Romania as a result',
  text13: 'with content that promoted Romania as a place worth visiting',
  imageAlt13: 'image',
  text5: 'according to the Ministry of Economy, Entrepreneurship and Tourism',
  imageAlt21: 'image',
  text211: 'outside money brought and spent in Romania as a result',
  text131: 'with content that promoted Romania as a place worth visiting',
  imageAlt111: 'image',
  imageAlt112: 'image',
  text110: '2B views generated',
  text181: 'average tourist spend',
  text20: 'to the economy',
  text171: 'of total international tourists in Romania in the last 4 years',
  text1: '2B views generated',
  text141: 'text here',
  text161: "that's 0.5%",
  text12: 'since 2019',
  imageSrc211: '/formula/arrow_black.svg',
  imageSrc12: '/formula/arrow_black.svg',
  text15: 'text here',
}

Formula2b.propTypes = {
  imageAlt211: PropTypes.string,
  imageSrc111: PropTypes.string,
  text31: PropTypes.string,
  caption22: PropTypes.string,
  text51: PropTypes.string,
  text3: PropTypes.string,
  text4: PropTypes.string,
  imageSrc22: PropTypes.string,
  text18: PropTypes.string,
  text16: PropTypes.string,
  imageAlt81: PropTypes.string,
  text2: PropTypes.string,
  imageSrc112: PropTypes.string,
  text121: PropTypes.string,
  imageSrc81: PropTypes.string,
  text201: PropTypes.string,
  text41: PropTypes.string,
  text210: PropTypes.string,
  imageSrc2: PropTypes.string,
  caption211: PropTypes.string,
  text151: PropTypes.string,
  rootClassName: PropTypes.string,
  text17: PropTypes.string,
  text14: PropTypes.string,
  text19: PropTypes.string,
  imageAlt12: PropTypes.string,
  imageAlt3: PropTypes.string,
  imageSrc11: PropTypes.string,
  text191: PropTypes.string,
  text21: PropTypes.string,
  text13: PropTypes.string,
  imageAlt13: PropTypes.string,
  text5: PropTypes.string,
  imageAlt21: PropTypes.string,
  text211: PropTypes.string,
  text131: PropTypes.string,
  imageAlt111: PropTypes.string,
  imageAlt112: PropTypes.string,
  text110: PropTypes.string,
  text181: PropTypes.string,
  text20: PropTypes.string,
  text171: PropTypes.string,
  text1: PropTypes.string,
  text141: PropTypes.string,
  text161: PropTypes.string,
  text12: PropTypes.string,
  imageSrc211: PropTypes.string,
  imageSrc12: PropTypes.string,
  text15: PropTypes.string,
}

export default Formula2b
